import React from 'react';
import { Section } from './ui/Section';
import { Moon, NotebookPen, Brain, Repeat } from 'lucide-react';
import { motion } from 'framer-motion';
import { useCountUp } from '../hooks/useCountUp';
function CounterCard({
  icon: Icon,
  title,
  desc,
  countTarget,
  countSuffix = '',
  index
}: any) {
  const {
    count,
    ref
  } = useCountUp(countTarget || 0, 1500, true);
  return <motion.div initial={{
    opacity: 0,
    y: 50,
    scale: 0.9
  }} whileInView={{
    opacity: 1,
    y: 0,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1,
    duration: 0.6,
    type: 'spring'
  }} className="bg-brand-navy p-8 rounded-2xl border border-white/5 shadow-md hover:shadow-xl hover:border-brand-indigo/30 transition-all duration-300 group relative overflow-hidden" data-id="element-215">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-indigo/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-216" />

      <div className="relative z-10" data-id="element-217">
        <div className="w-14 h-14 bg-brand-indigo/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-indigo/20 transition-colors group-hover:scale-110 duration-300" data-id="element-218">
          <Icon className={`text-brand-indigo ${!countTarget ? 'group-hover:rotate-12 transition-transform' : ''}`} size={28} data-id="element-219" />
        </div>

        <h3 className="font-heading text-2xl text-white mb-3 flex items-center gap-3 uppercase tracking-wide" data-id="element-220">
          {countTarget && <span className="text-brand-amber font-bold text-3xl tabular-nums" ref={ref} data-id="element-221">
              {count}
              {countSuffix}
            </span>}
          <span data-id="element-222">{title}</span>
        </h3>

        <p className="text-slate-400 text-lg leading-relaxed" data-id="element-223">{desc}</p>
      </div>
    </motion.div>;
}
export default function MechanismSection() {
  return <Section id="mechanism" className="bg-brand-dark" data-id="element-224">
      <div className="text-center mb-16" data-id="element-225">
        <h2 className="font-heading text-4xl md:text-6xl text-white mb-4 uppercase tracking-wide" data-id="element-226">
          El Triángulo{' '}
          <span className="text-brand-indigo border-b-4 border-brand-indigo relative inline-block" data-id="element-227">
            NOCHE
            <motion.span initial={{
            width: 0
          }} whileInView={{
            width: '100%'
          }} transition={{
            delay: 0.5,
            duration: 0.8
          }} className="absolute bottom-0 left-0 h-1 bg-brand-amber" data-id="element-228" />
          </span>
        </h2>
        <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto" data-id="element-229">
          APAGA LA MENTE es un protocolo simple para el momento real: cuando ya
          estás en la cama y tu mente no se calla.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-230">
        <CounterCard icon={NotebookPen} title="DESCARGA" desc="Sacas de tu cabeza lo que está dando vueltas. No «escribes bonito». Vacías." countTarget={6} countSuffix=" min" index={0} data-id="element-231" />
        <CounterCard icon={Brain} title="DESENGANCHE" desc="En vez de discutir con tu mente, cortas el circuito con una frase simple y una ancla corporal." index={1} data-id="element-232" />
        <CounterCard icon={Moon} title="RITUAL MÍNIMO" desc="Tres señales físicas pequeñas que tu cuerpo aprende a asociar con «ya terminó»." countTarget={3} index={2} data-id="element-233" />
        <CounterCard icon={Repeat} title="14 NOCHES" desc="Un plan progresivo que entrena el nuevo patrón. No una noche. Un sistema." countTarget={14} index={3} data-id="element-234" />
      </div>
    </Section>;
}